<template lang="pug">
  Modal(v-if="modal.show", @close="modal.show=false", class="sending_school_modal", modalWidth="large")
    span(slot="header" class="sending_school_header") {{ modal.title }}
    template(slot="content" class="sending_school_content")
      validation-observer(ref="observer" tag="form" @submit.prevent="getSchool")
        .row
          .form-col.large-16   
            input(type="text", placeholder="Enter School Name", v-model='searchTerm')
          .form-col.large-4
            .select.has-id-query_state.placeholder
              span.selected
                span.value {{selected_state || t('helpers.placeholder.address.state')}}
                span.caret
              select.for-panel-select(v-model="search_params.query_state")
                option(:value="null") {{t('helpers.placeholder.address.state')}}
                option(v-for="(state, code) in STATE_CODES" :key="code" :value="code",) {{ state }}
          .form-col.large-4
            button.buttons.right(class="button primary" type="submit" @click="validate") {{t("app.programs.search.button") }}
        div.content-block.loader#no-results-found(v-if="loading")
          span {{ schools === this.noResultsMessage ? 'No results' : 'Loading....' }}
        article.content-block(v-if="currentSchools.length && !loading")
          header.search_result_header
            .title.title-with-button
              | Search Results
          .content
            div.show_list
              .row(v-for='school in currentSchools', :key='school' class="show_list_on_modal")
                div
                  .columns.large-4
                    img(:src="schoolLogoUrl(school.logo)") 
                  .columns.large-20
                    a(@click="(modal.title === 'Previous School' || modal.title === 'Receiving School') ? passName(school) : passName(school.name)")
                      .name {{ school.name }}
                      .address {{school.address}}
                      .addressline2 {{ school.city }}, {{ school.state }}, {{ school.postalCode }}
          pagination(:records="schools" :records-per-page="recordsPerPage" v-model="currentPage")
        div.pagination(v-if="!loading")
          a.prev(v-if="currentPage > 1" @click="currentPage--")  &lt;&lt;Prev
          a.page(v-for="page in [currentPage]"
            :key="page"
            :class="{ active: currentPage === page }"
            @click="currentPage = page"
            v-if="page > 0 && page <= pageCount") {{ page }}
          a.next(v-if="hasNextPage" @click="currentPage++") Next>>
        .row
          .form-col.large-24
          .buttons.cancel(v-bind:style="{ marginTop: (currentSchools.length ? '3rem' : '30rem'), marginLeft: '0.35rem' }")
            .left
              a(@click="modal.show=false" class="button secondary") {{t('app.buttons.cancel')}}         
</template>
<script>

import Modal from "../shared/_modal";
import states from 'templates/shared/states'
import Loader from '../shared/_loader'

export default {
  components: { Modal, Loader},
  mixins: [states],
  props: {
    registration: {
      type: Object,
      default() {
        return {}
      },
    },
    modal: {
      type: Object,
      default() {
        return {}
      },
    },
    schools: {
      type: Array,
      default() {
        return []
      },
    },
    result: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      name: this.schools.name,
      searchTerm: '',
      internal_result: this.result,
      search_params: {
        query: '',
        query_state: this.registration.program.main_address_state,
      },
      currentPage: 1,
      recordsPerPage: 25,
      countries: [],
      loading: false,
      noResultsMessage: 'No Schools were found given the criteria.',
    }
  },
  computed: {
    selected_state: {
      get() {
        return this.STATE_CODES[this.search_params.query_state]
      },
      set(value) {
        this.STATE_CODES[this.search_params.query_state] = value
      },
    },
    currentSchools() {
      let start = (this.currentPage - 1) * this.recordsPerPage
      let end = start + this.recordsPerPage
      return this.schools.slice(start, end)
    },
    hasNextPage() {
      return this.currentPage * this.recordsPerPage < this.schools.length
    },
    pageCount() {
      return Math.ceil(this.schools.length / this.recordsPerPage)
    },
  },
  watch: {
    currentPage(newPage) {
      let totalPages = Math.ceil(this.schools.length / this.recordsPerPage)
      if (newPage < 1) {
        this.currentPage = 1
      } else if (newPage > totalPages) {
        this.currentPage = totalPages
      }
    },
  },
  methods: {
    schoolLogoUrl(logoUrl) {
    const defaultLogoUrl = "https://fiddevpublic.blob.core.windows.net/www-familyid-me/packs/static/logo-default-bbdb21ebfb5a235e49e9.png";
    if (logoUrl) {
      const img = new Image();
      img.src = logoUrl;
      if (img.complete) {
        return logoUrl;
      } else {
        return defaultLogoUrl;
      }
    } 
    else 
    {
      return defaultLogoUrl;
    }
    },
    getSchool() {
      this.axios
        .get(`/api2/family/registrations/get_arbiter_sending_schools`, {
          params: {
            StateAbbreviation: this.search_params.query_state,
            name: this.searchTerm,
            per: this.per,
          },
        })
        .then((response) => {
          this.schools = response.data.object
          this.loading = false
          if(this.schools === this.noResultsMessage) {
            this.loading = true
            this.$el.querySelector('#no-results-found span').textContent = 'No results'
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    passName(name, event) {
      this.$emit('name-selected', name)
      this.$set(this.modal, 'show', false)
    },
    validate() {
      this.$refs.observer.validate().then((valid) => {
      if (!valid) return
      this.getSchool()
      this.loading = true
      if (this.schools === this.noResultsMessage) {
          setTimeout(() => {
          this.$nextTick(() => {
          this.$el.querySelector('#no-results-found span').textContent = 'Loading....'
          })
        }, 300)
      }
      })
    },
  },
}
</script>
<style scoped>
  .button{
      width: 110px;
  }
  .button.primary{
      margin-top: -0.0625rem;
  }
  .buttons.cancel{
      margin-top: 30rem;
      margin-left: 0.35rem;
  }
  .name{
      margin-top: 0.625rem;
      font-weight: bold;
      font-size: 1.3rem;
  }
  .sending_school_header_result{
      background: transparent !important;
      padding: rem(0 15px 15px) !important;
  }
  .show_list{
      margin-top: 1rem;
      overflow-y: auto;
      overflow-x: hidden; 
      max-height: 500px;
  }
  .show_list_on_modal{
      height: 4rem;
      margin-bottom: 2rem;
  }
  img{
      width: 5rem;
      height: 4rem;
  }
  .title.title-with-button{
      color: #1b3d73;
      background: #e5eaf2;
  }
  .search_result_header{
      background-color: #e5eaf2;
      margin-top: 2rem;
  }
  .pagination{
      margin-top: 2rem;
  }
  .address, .addressline2{
      color: black;
      font-weight: 500;
  }
  .next,
  .page,
  .prev{
      border-style: none;
      border-width: 0;
      cursor: pointer;
      font-family: inherit;
      font-weight: normal;
      margin: 0 0 0;
      position: relative;
      text-decoration: none;
      text-align: center;
      background-color: #f5f7fa;
      border-color: #d3dce9;
      color: #05101a;
      padding-right: 1.25em;
      padding-left: 1.25em;
      font-size: 0.75em;
      padding-top: 0.6875em;
      padding-bottom: 0.625em;
      margin-bottom: 1em;
      margin-left: 1em;
  }
  .show_list::-webkit-scrollbar {
      width: 5px;
  }
  .show_list::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  }
  .show_list::-webkit-scrollbar-thumb {
  background-color: #888;
  }
  .show_list::-webkit-scrollbar-thumb:hover {
  background-color: #555;
  }
  .content-block.loader{
    margin-top: 2rem;
  } 
</style>
